import { VerifyCurrentPasswordTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const VerifyCurrentPasswordTrackingSchema: Record<
  VerifyCurrentPasswordTrackingPoint,
  string
> = {
  [VerifyCurrentPasswordTrackingPoint.PageView]: '',
  [VerifyCurrentPasswordTrackingPoint.NextButtonClick]: '',
  [VerifyCurrentPasswordTrackingPoint.BackButtonClick]: '',
};

export const getVerifyCurrentPasswordPageTypeAndSchema = (
  trackingPoint: VerifyCurrentPasswordTrackingPoint
) => {
  return {
    page_type: PageType.VerifyCurrentPasswordPage,
    schema: VerifyCurrentPasswordTrackingSchema[trackingPoint],
  };
};
